export type ContentVariantFields = {
  description: string;
  dismiss: string;
  imgSrc: string;
  title: string;
  support: string;
};

enum KnownContentVariant {
  SOLUTION = 'solution',
  URGENCY = 'urgency',
}

const getImageForContentVariant = (
  knownContentVariant: KnownContentVariant,
): string =>
  knownContentVariant === KnownContentVariant.SOLUTION
    ? '/images/copter-small.gif'
    : '/images/logo-small.gif';

export const contentVariantFields = (): ContentVariantFields => {
  // Randomly show them one of the two variants we are using
  const contentVariant =
    Math.random() > 0.5
      ? KnownContentVariant.SOLUTION
      : KnownContentVariant.URGENCY;

  const imgSrc = getImageForContentVariant(contentVariant);

  return {
    description: `supportUsBanner.${contentVariant}.description`,
    dismiss: `supportUsBanner.${contentVariant}.notNow`,
    imgSrc,
    support: `supportUsBanner.${contentVariant}.waysToGive`,
    title: `supportUsBanner.${contentVariant}.title`,
  };
};
